
// @ts-nocheck


export const localeCodes =  [
  "cs",
  "en",
  "pl",
  "sk",
  "de"
]

export const localeLoaders = {
  "cs": [{ key: "../locales/load.js", load: () => import("../locales/load.js?hash=6d85ed5e&locale=cs" /* webpackChunkName: "locale__home_aquarist_www_pipeclub_locales_load_js" */), cache: false }],
  "en": [{ key: "../locales/load.js", load: () => import("../locales/load.js?hash=6d85ed5e&locale=cs" /* webpackChunkName: "locale__home_aquarist_www_pipeclub_locales_load_js" */), cache: false }],
  "pl": [{ key: "../locales/load.js", load: () => import("../locales/load.js?hash=6d85ed5e&locale=cs" /* webpackChunkName: "locale__home_aquarist_www_pipeclub_locales_load_js" */), cache: false }],
  "sk": [{ key: "../locales/load.js", load: () => import("../locales/load.js?hash=6d85ed5e&locale=cs" /* webpackChunkName: "locale__home_aquarist_www_pipeclub_locales_load_js" */), cache: false }],
  "de": [{ key: "../locales/load.js", load: () => import("../locales/load.js?hash=6d85ed5e&locale=cs" /* webpackChunkName: "locale__home_aquarist_www_pipeclub_locales_load_js" */), cache: false }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "~_i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false,
    "jsTsFormatResource": true
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "~/i18n.config.ts",
  "locales": [
    {
      "code": "cs",
      "language": "cs-CZ",
      "files": [
        "/home/aquarist/www/pipeclub/locales/load.js"
      ]
    },
    {
      "code": "en",
      "language": "en-US",
      "files": [
        "/home/aquarist/www/pipeclub/locales/load.js"
      ]
    },
    {
      "code": "pl",
      "language": "pl-PL",
      "files": [
        "/home/aquarist/www/pipeclub/locales/load.js"
      ]
    },
    {
      "code": "sk",
      "language": "sk-SK",
      "files": [
        "/home/aquarist/www/pipeclub/locales/load.js"
      ]
    },
    {
      "code": "de",
      "language": "de-DE",
      "files": [
        "/home/aquarist/www/pipeclub/locales/load.js"
      ]
    }
  ],
  "defaultLocale": "cs",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "locales/",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "warnHtmlMessage": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "cs",
    "language": "cs-CZ",
    "files": [
      {
        "path": "/home/aquarist/www/pipeclub/locales/load.js"
      }
    ]
  },
  {
    "code": "en",
    "language": "en-US",
    "files": [
      {
        "path": "/home/aquarist/www/pipeclub/locales/load.js"
      }
    ]
  },
  {
    "code": "pl",
    "language": "pl-PL",
    "files": [
      {
        "path": "/home/aquarist/www/pipeclub/locales/load.js"
      }
    ]
  },
  {
    "code": "sk",
    "language": "sk-SK",
    "files": [
      {
        "path": "/home/aquarist/www/pipeclub/locales/load.js"
      }
    ]
  },
  {
    "code": "de",
    "language": "de-DE",
    "files": [
      {
        "path": "/home/aquarist/www/pipeclub/locales/load.js"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
